import { Activity, CheckCircle2 } from "lucide-react"
import { cn } from "@/lib/utils"

const MILESTONES = [
  { count: 5, title: "Initial Flow", desc: "Consistently sourcing deals" },
  { count: 10, title: "Appraisal Consistency", desc: "Reliably analysing deals" },
  { count: 15, title: "Negotiation Active", desc: "Engaging vendors" },
  { count: 20, title: "Pipeline Stability", desc: "Full loop functioning" },
]

const MAX_DEALS = 20

export function EarlyMomentumProgressBar({ activePipelineCount = 0 }) {
  const progress = Math.min(100, (activePipelineCount / MAX_DEALS) * 100)

  return (
    <div className="border-b border-border bg-card px-6 py-4">
      <div className="mx-auto max-w-[1600px]">
        <div className="mb-3 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Activity className="h-4 w-4 text-primary" />
            <h2 className="text-sm font-bold text-foreground">Early Stage Momentum</h2>
          </div>
          <span className="font-mono text-xs font-bold text-primary">
            {activePipelineCount} / {MAX_DEALS} Deals
          </span>
        </div>

        <div className="mb-4 h-1.5 w-full overflow-hidden rounded-full bg-muted shadow-inner">
          <div
            className="h-full rounded-full bg-primary shadow-[0_0_10px_var(--color-primary)] transition-all duration-1000 ease-in-out"
            style={{ width: `${progress}%` }}
          />
        </div>

        <div className="flex items-center gap-2 overflow-x-auto pb-2">
          {MILESTONES.map((milestone) => {
            const achieved = activePipelineCount >= milestone.count
            return (
              <div
                key={milestone.count}
                className={cn(
                  "min-w-[120px] flex-1 rounded-lg border px-3 py-2 transition-all",
                  achieved ? "border-primary/50 bg-primary/10 shadow-sm" : "border-border bg-transparent opacity-60",
                )}
              >
                <div className="mb-1 flex items-center justify-between">
                  <span
                    className={cn(
                      "text-[10px] font-bold uppercase tracking-widest",
                      achieved ? "text-primary" : "text-muted-foreground",
                    )}
                  >
                    {milestone.count} Deals
                  </span>
                  {achieved ? <CheckCircle2 className="h-3 w-3 text-primary" /> : null}
                </div>
                <p className={cn("text-xs font-bold", achieved ? "text-foreground" : "text-muted-foreground")}>
                  {milestone.title}
                </p>
                <p className={cn("mt-0.5 text-[10px]", achieved ? "text-primary/80" : "text-muted-foreground")}>
                  {milestone.desc}
                </p>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
